import React from 'react';
import AppLogo from '@assets/images/bella-bona-logo.svg';
import styles from './auth-hoc.scss';
// New BELLA BONA wordmark, same artwork as the new-gen admin app (admin/src/client/Logo.tsx).
const AppIcon = () => (React.createElement("div", { className: styles.app_logo_wrapper },
    React.createElement("img", { src: AppLogo, alt: 'Bella & Bona', className: styles.app_logo }),
    React.createElement("h2", { className: styles.admin_label }, "Admin Site")));
export default AppIcon;
